import { Type } from "@sinclair/typebox";

import {
  PaginationParamsSchema,
  PaginationSchema,
  SortParamSchema,
} from "../shared/schema.js";

export enum BlockEventType {
  Block = "sperren",
  Free = "freigeben",
}

export enum BlockType {
  AllSurveys = "alle_befragungen",
  PopulationSurveys = "bevoelkerungs_befragungen",
}

export const BlockEventSchema = Type.Object({
  eventType: Type.Enum(BlockEventType),
  prefix: Type.String({ pattern: "^0[0-9]{2,5}$" }),
  number: Type.String({ pattern: "^[0-9x*]{3,10}$" }),
  isPrivate: Type.Boolean(),
  blockType: Type.Enum(BlockType),
  blockSize: Type.Number({ minimum: 1, maximum: 11111 }),
  comment: Type.String({ maxLength: 1024 }),
  verified: Type.Optional(Type.Boolean()),
});

export const BlockEventHistorySchema = Type.Composite([
  BlockEventSchema,
  Type.Object({
    id: Type.Number(),
    institute: Type.String(),
    created: Type.String({ format: "date-time" }),
    updatedAt: Type.String({ format: "date-time" }),
  }),
]);

export const BlockEventHistoryWithUserNameSchema = Type.Composite([
  BlockEventHistorySchema,
  Type.Object({
    user: Type.String(),
  }),
]);

export const BlockCheckSchema = Type.Object({
  prefix: Type.String({ maxLength: 6 }),
  number: Type.String({ maxLength: 8 }),
  total: Type.Number(),
  private: Type.Number(),
  notPrivate: Type.Number(),
  blockedForAllSurveys: Type.Number(),
  blockedForPopulationSurveys: Type.Number(),
});

export const StoreBlockEventRequestBodySchema = Type.Object({
  events: Type.Array(BlockEventSchema, { minItems: 1 }),
});

export const StoreBlockEventResponseSchema = Type.Object({
  inserted: Type.Number(),
  updated: Type.Number(),
});

export const GetRecentBlockEventsRequestParamsSchema = Type.Composite([
  PaginationParamsSchema,
  SortParamSchema,
]);

export const GetRecentBlockEventsResponseSchema = Type.Object({
  events: Type.Array(BlockEventHistorySchema),
  pagination: PaginationSchema,
});

export const FreeBlockEventRequestParamsSchema = Type.Object({
  id: Type.Number(),
});

export const FreeBlockEventSuccessResponseSchema = Type.Object({
  freed: Type.Number(),
});

export const UpdateBlockEventRequestBodySchema = Type.Object({
  id: Type.Number(),
  updatedValues: BlockEventSchema,
});

export const UpdateBlockEventSuccessResponseSchema = Type.Object({
  inserted: Type.Number(),
  deleted: Type.Number(),
});

export const GetNotVerifiedBlockEventsSuccessResponseSchema = Type.Object({
  events: Type.Array(BlockEventHistoryWithUserNameSchema),
  pagination: PaginationSchema,
});

export const VerifyBlockEventRequestParamsSchema = Type.Object({
  id: Type.Number(),
});

export const VerifyBlockEventSuccessResponseSchema = Type.Object({});
